import { Alert, AlertTitle, Grid, Stack, Typography, useTheme } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import useDrawerContext from 'v2/components/Drawer/useDrawerContext';
import Loader from 'v2/components/Loader/Loader';
import useDeviceGroupsInfo from 'v2/hooks/useDeviceGroupsInfo/useDeviceGroupsInfo';
import { getUserGroupPath } from 'v2/paths';
import EditUserGroupsDrawer from '../drawers/EditUserGroupsDrawer/EditUserGroupsDrawer';
import GroupCard from './GroupCard';

interface Props {
  deviceId: string;
}

const UserGroupsCard: React.FC<Props> = ({ deviceId }) => {
  const { translation } = useTranslation();
  const theme = useTheme();
  const { openDrawer } = useDrawerContext();
  const navigate = useNavigate();
  const deviceGroupsInfo = useDeviceGroupsInfo(deviceId);

  if (deviceGroupsInfo.isLoading)
    return (
      <Grid width="100%" height="100%" justifyContent="center" alignItems="center">
        <Loader />
      </Grid>
    );

  const { userGroupsWithAccess, isDeviceAccessible } = deviceGroupsInfo;

  const emptyAlert = isDeviceAccessible ? (
    <Typography variant="body2" color="textSecondary">
      {translation.not_assigned_to_user_groups}
    </Typography>
  ) : (
    <Alert variant="standard" severity="error" sx={{ backgroundColor: theme.custom.status.error.selected }}>
      <Stack direction="column">
        <AlertTitle style={{ color: theme.palette.error.light }}>{translation.no_user_groups_assigned}</AlertTitle>
        <Typography variant="body2" style={{ color: theme.palette.error.light }}>
          {translation.add_to_user_group}
        </Typography>
      </Stack>
    </Alert>
  );

  return (
    <GroupCard
      title={translation.user_groups}
      groups={userGroupsWithAccess}
      editButtonId="editUserGroups"
      emptyAlert={userGroupsWithAccess.length === 0 ? emptyAlert : undefined}
      onGroupClick={(id) => navigate(getUserGroupPath(id))}
      onEditClick={() => openDrawer(<EditUserGroupsDrawer deviceId={deviceId} />)}
    />
  );
};

export default UserGroupsCard;
